import React, { useState, useEffect } from 'react';
import { Paper, Grid, Avatar, Chip, Typography, InputAdornment, CircularProgress, TextField, IconButton, Card, CardContent, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import EmptyState from '../../components/Error/EmptyState';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import CreateTicket from '../MyChecklist/CreateTicket';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from 'react-bootstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const MyStationChecklistItems = (props) => {
    let navigate = useNavigate();
    const [addModal, setAddModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [generalModal, setGeneralModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { id, scheduleId } = useParams();
    const [searchResult, setSearchResult] = useState('');
    const [checklistItems, setChecklistItems] = useState([]);
    const [generalizedTicket, setGeneralizedTicket] = useState(null);
    const [disableItem, setDisableItem] = useState(false);
    const [checklistItemId, setChecklistItemId] = useState('')
    const [scheduleReportId, setScheduleReportId] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState('')
    const [itemName, setItemName] = useState('')
    const [ticketDetail, setTicketDetail] = useState('')
    const [title, setTitle] = useState('')
    const [status, setStatus] = useState("");
    const [ticketAssigned, setTicketAssigned] = useState('');
    const [locName, setLocName] = useState("");
    const [checkArray , setCheckArray] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [openCategories, setOpenCategories] = useState({});
    const [locationDrop, setLocationDrop] = useState([]);
    const [selectedStation, setSelectedStation] = useState("all");

    const toggleRow = (itemId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };

    const getChecklistData = () => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId
        }
        ApiService.post('/checklist/data', body)
            .then((data) => {
                setTitle(data?.title)
                setStatus(data?.schedule?.status || "");
                setTicketAssigned(data?.ticket_assigned_to || "")
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const getGeneralizedTicket = (loader = true) => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId
        }
        if (loader) {
            setLoading(true)
        }
        ApiService.post('/tickets/checklists/view-genralized-ticket', body)
            .then(({ data }) => {
                setGeneralizedTicket(data)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const getChecklistItems = (loader = true) => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId,
            "search": searchResult
        }
        if (loader) {
            setLoading(true)
        }
        ApiService.post('/checklist-user/item', body)
            .then(({ data }) => {
                setChecklistItems(data)
                getGeneralizedTicket()
                setLoading(false);

            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const UpdateStatus = (item, status) => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId,
            "checklist_station_item_id": item?.id,
            "status": status,
        }
        ApiService.post('/checklist-user/station-items/status', body)
            .then((data) => {
                toast.success(data?.message)
                getChecklistItems(false)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const RevertStatus = (item, status) => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId,
            "checklist_station_item_id": item?.id,
            "status": item?.schedule_reports?.status
        }

        ApiService.post('/checklist-user/station-items/revert-status', body)
            .then((data) => {
                toast.success(data?.message)
                getChecklistItems(false)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const Submit = () => {
        const body = {
            'checklist_id': id,
            "checklist_schedule_id": scheduleId,
        }
        ApiService.post('/checklist-user/checklist-schedules/status', body)
            .then((data) => {
                navigate("/firehouse/my-station-checklist");
                toast.success(data?.message)
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false)
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.data.message)
                }
            })
    }

    const deleteItem = () => {
        setLoading(true);
        const body = {
            checklist_ticket_id: deleteId
        }
        ApiService.post('/tickets/checklists/delete', body)
            .then(({ data }) => {
                setDeleteId('')
                setDeleteModal(false)
                getChecklistItems()
                toast.success(data.message)
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message)
            })
    }

    const viewItem = (id) => {
        const body = {
            checklist_ticket_id: id
        }
        ApiService.post('/tickets/checklists/view-ticket', body)
            .then(({ data }) => {
                setTicketDetail(data)
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message)
            })
    }

    useEffect(() => {
        getChecklistItems()
        getChecklistData()

    }, [])

    useEffect(() => {
        getChecklistItems(false)
    }, [searchResult])

    const checklistItemsCheck = () => {
        const body = {
            'checklist_id': id,
        }
        ApiService.post('/checklist-user/item-id', body)
            .then((data) => {
                setCheckArray(data?.data || [])
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(()=>{
        checklistItemsCheck()
    }, [])

    useEffect(() => {
        getLocation()
    }, [])

    const getLocation = () => {
        ApiService.get('/checklist/location')
            .then(({ data }) => {
                const posArr = data?.data?.map((pos) => ({ label: pos.location_description, value: pos.id })) || [];
                setLocationDrop(posArr);
            })
            .catch(() => {});
    }

    const getLocationName = (id) => {
        if (!id) return "";
        const match = locationDrop.find(l => l.value == id);
        return match ? match.label : "";
    }

    const uniqueStations = [...new Set((checklistItems || []).map(i => i.location_id).filter(Boolean))];

    const filteredChecklistItems = selectedStation === "all"
        ? checklistItems
        : (checklistItems || []).filter(i => i.location_id == selectedStation);

    const groupedChecklistItems = filteredChecklistItems && filteredChecklistItems.length > 0 ? filteredChecklistItems.reduce((acc, item) => {
        const key = item.category || "No category";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {}) : {};

    const toggleCategory = (category) => {
        setOpenCategories(prev => ({ ...prev, [category]: !prev[category] }));
    };

    // Default all categories to open when checklistItems load
    useEffect(() => {
        if (checklistItems && checklistItems.length > 0) {
            const allOpen = checklistItems.reduce((acc, item) => {
                acc[item.category || "No category"] = true;
                return acc;
            }, {});
            setOpenCategories(prev => {
                // Only set keys that don't already exist (preserve user toggles)
                const merged = { ...prev };
                Object.keys(allOpen).forEach(key => {
                    if (!(key in merged)) merged[key] = true;
                });
                return merged;
            });
        }
    }, [checklistItems]);

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>)
                :
                (<>
                    <Paper className="p-4" style={{ marginTop: "1rem" }}>
                        <Grid container className='align-items-center' gap={2} fontFamily={'karla'}>

                            {/* Heading */}
                            <Grid item xs={10} md={9} sx={{ minWidth: '80% !important' }}>
                                <Typography variant="h5">
                                    <Link to="/firehouse/my-station-checklist" style={{ color: "black" }}>
                                        <ArrowBackIosIcon />
                                    </Link>
                                    {`Checklist > ${title}`}</Typography>  
                            </Grid>

                            {/* Search field */}
                            <Grid item xs={12} sm={12} md={2}>
                                <TextField
                                    variant="outlined"
                                    placeholder="Search"
                                    onChange={(e) => setSearchResult(e.target.value)}
                                    className="w-100"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            height: '48px',
                                            fontSize: '14px',
                                        },
                                    }}
                                />
                            </Grid>

                            {!checklistItems || checklistItems.length == 0 ?
                                <div className='d-flex align-items-center w-100' style={{ height: 550 }}>
                                    <EmptyState />
                                </div>
                                :
                                <Grid item className='align-items-center p-2' fontFamily={'karla'} md={12}>
                                    {uniqueStations.length > 0 && (
                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, overflowX: 'auto' }}>
                                            <div
                                                onClick={() => setSelectedStation("all")}
                                                style={{
                                                    cursor: 'pointer',
                                                    padding: '8px 16px',
                                                    borderRadius: '999px',
                                                    fontSize: 13,
                                                    fontFamily: 'karla, sans-serif',
                                                    userSelect: 'none',
                                                    whiteSpace: 'nowrap',
                                                    backgroundColor: selectedStation === "all" ? "#BF1D2D" : "#f0f0f0",
                                                    color: selectedStation === "all" ? "#fff" : "#555",
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                All
                                            </div>
                                            {uniqueStations.map(stationId => (
                                                <div
                                                    key={stationId}
                                                    onClick={() => setSelectedStation(stationId)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '8px 16px',
                                                        borderRadius: '999px',
                                                        fontSize: 13,
                                                        fontFamily: 'karla, sans-serif',
                                                        userSelect: 'none',
                                                        whiteSpace: 'nowrap',
                                                        backgroundColor: selectedStation == stationId ? "#BF1D2D" : "#f0f0f0",
                                                        color: selectedStation == stationId ? "#fff" : "#555",
                                                        transition: 'all 0.2s'
                                                    }}
                                                >
                                                    {getLocationName(stationId) || 'Unknown'}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    <div className='font-fam mt-2'>
                                        {Object.entries(groupedChecklistItems).map(([category, items], catIndex) => {
                                            const isCatOpen = openCategories[category];

                                            return (
                                                <div key={category} style={{ marginBottom: 16 }}>

                                                    {/* Category Header */}
                                                    <div
                                                        onClick={() => toggleCategory(category)}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            padding: '8px 4px',
                                                            borderBottom: '1px solid #e0e0e0',
                                                            userSelect: 'none'
                                                        }}
                                                    >
                                                        <span style={{
                                                            marginRight: 10, fontSize: 10, color: '#999',
                                                            transform: isCatOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'inline-block'
                                                        }}>
                                                            ▶
                                                        </span>
                                                        <span style={{
                                                            minWidth: 22, height: 22, borderRadius: '50%',
                                                            background: '#BF1D2D', color: '#fff',
                                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                            fontSize: 11, fontWeight: 700, marginRight: 10, flexShrink: 0
                                                        }}>
                                                            {catIndex + 1}
                                                        </span>
                                                        <span style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                                                            {category}
                                                        </span>
                                                        <span style={{ marginLeft: 8, fontSize: 12, color: '#aaa', fontWeight: 400 }}>
                                                            ({items.length} {items.length === 1 ? 'item' : 'items'})
                                                        </span>
                                                    </div>

                                                    {/* Child Items */}
                                                    <div style={{
                                                        maxHeight: isCatOpen ? 5000 : 0,
                                                        overflow: 'hidden',
                                                        transition: 'max-height 0.3s ease'
                                                    }}>
                                                        <div style={{
                                                            marginLeft: 16,
                                                            borderLeft: '2px solid #e0e0e0',
                                                            paddingLeft: 16,
                                                            marginTop: 8
                                                        }}>
                                                            {items.map((item, i) => {
                                                                const allItems = item?.location?.all_items || [];
                                                                const filteredItems = allItems.filter(fi => !checkArray.includes(fi.id));
                                                                const isExpanded = expandedRows[item.id];

                                                                return (
                                                                    <div key={item.id || i} style={{ position: 'relative' }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 10,
                                                                            padding: '10px 0',
                                                                            borderBottom: i < items.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                            position: 'relative',
                                                                            flexWrap: 'wrap'
                                                                        }}>
                                                                            {/* Horizontal connector line */}
                                                                            <div style={{
                                                                                position: 'absolute', left: -16, top: '50%',
                                                                                width: 12, height: 0, borderTop: '2px solid #e0e0e0'
                                                                            }} />
                                                                            <div style={{
                                                                                width: 6, height: 6, borderRadius: '50%',
                                                                                background: '#BF1D2D', flexShrink: 0
                                                                            }} />

                                                                            {/* Expand toggle for sub-items */}
                                                                            {filteredItems.length > 0 && (
                                                                                <div onClick={() => toggleRow(item.id)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                                                                    {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                                                                                </div>
                                                                            )}

                                                                            {/* Description + Parent Station */}
                                                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 150 }}>
                                                                                <span style={{
                                                                                    fontSize: 13,
                                                                                    color: !item.description ? '#ccc' : '#555',
                                                                                    fontStyle: !item.description ? 'italic' : 'normal',
                                                                                    lineHeight: 1.5
                                                                                }}>
                                                                                    {item.description || "No description"}
                                                                                </span>
                                                                                {item?.location_id && (
                                                                                    <span style={{ fontSize: 12, color: '#2B3F6C', fontWeight: 500 }}>
                                                                                        Parent Station: <span style={{ fontWeight: 400, color: '#555' }}>{getLocationName(item?.location_id) || '—'}</span>
                                                                                    </span>
                                                                                )}
                                                                            </div>

                                                                            {/* Status / Action Chips */}
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0, flexWrap: 'wrap' }}>
                                                                                {item?.schedule_reports?.status == 'pass' ?
                                                                                    <Chip
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        sx={{ backgroundColor: '#DDDDDD00', color: '#2B3F6C', border: '1px solid #2B3F6C80' }}
                                                                                        avatar={<Avatar src="/images/check1.png" style={{ width: 24, height: 24, padding: 5 }} />}
                                                                                        label={'Passed'}
                                                                                    /> :
                                                                                    item?.schedule_reports?.status == 'failed' ?
                                                                                        item?.schedule_reports?.checklist_ticket_id != null ?
                                                                                            <>
                                                                                                <Chip variant="outlined" size="small"
                                                                                                    sx={{ backgroundColor: '#DDDDDD00', color: '#BF1D2D', border: '1px solid #BF1D2D' }}
                                                                                                    avatar={<Avatar src="/images/red-cross.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                                    label={'Failed'}
                                                                                                />
                                                                                                <Chip variant="outlined" size="small"
                                                                                                    sx={{ backgroundColor: '#EAECF0', color: '#2B3F6C', border: '1px solid #2B3F6C', cursor: 'pointer' }}
                                                                                                    avatar={<Avatar src="/images/eye.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                                    label={'View Ticket'}
                                                                                                    onClick={() => {
                                                                                                        viewItem(item?.schedule_reports?.checklist_ticket_id)
                                                                                                        setShowModal(true)
                                                                                                    }}
                                                                                                />
                                                                                                {status !== "completed" && status !== "failed" && (
                                                                                                    <Chip variant="outlined" size="small"
                                                                                                        sx={{ backgroundColor: '#0000000D', color: '#000000', border: '1px solid #000000', cursor: 'pointer' }}
                                                                                                        avatar={<Avatar src="/images/delete1.png" style={{ width: 18, height: 18, padding: 2 }} />}
                                                                                                        label={'Delete Ticket'}
                                                                                                        onClick={() => {
                                                                                                            setDeleteId(item?.schedule_reports?.checklist_ticket_id)
                                                                                                            setDeleteModal(true)
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                                <Chip variant="outlined" size="small"
                                                                                                    sx={{ backgroundColor: '#DDDDDD00', color: '#BF1D2D', border: '1px solid #BF1D2D' }}
                                                                                                    avatar={<Avatar src="/images/red-cross.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                                    label={'Failed'}
                                                                                                />
                                                                                                {status !== "completed" && status !== "failed" && (
                                                                                                    <Chip variant="outlined" size="small"
                                                                                                        sx={{ backgroundColor: '#0000000D', color: '#000000', border: '1px solid #000000', cursor: 'pointer' }}
                                                                                                        avatar={<Avatar src="/images/add.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                                                                                        label={'Create Ticket'}
                                                                                                        onClick={() => {
                                                                                                            setAddModal(true)
                                                                                                            setDisableItem(false)
                                                                                                            setChecklistItemId(item?.id)
                                                                                                            setScheduleReportId(item?.schedule_reports?.id)
                                                                                                            setItemName(item?.item_location?.item?.item_description)
                                                                                                            setLocName(item?.location?.location_description)
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </>
                                                                                        :
                                                                                        <>
                                                                                            <Chip variant="outlined" size="small"
                                                                                                sx={{ backgroundColor: '#DDDDDD00', color: '#BF1D2D', border: '1px solid #BF1D2D', cursor: 'pointer' }}
                                                                                                avatar={<Avatar src="/images/red-cross.png" style={{ width: 24, height: 24, padding: 4 }} />}
                                                                                                label={'No'}
                                                                                                onClick={() => UpdateStatus(item, 'failed')}
                                                                                            />
                                                                                            <Chip variant="outlined" size="small"
                                                                                                sx={{ backgroundColor: '#DDDDDD00', color: '#2B3F6C', border: '1px solid #2B3F6C80', cursor: 'pointer' }}
                                                                                                avatar={<Avatar src="/images/check1.png" style={{ width: 24, height: 24, padding: 5 }} />}
                                                                                                label={'Yes'}
                                                                                                onClick={() => UpdateStatus(item, 'pass')}
                                                                                            />
                                                                                        </>
                                                                                }

                                                                                {(item?.schedule_reports?.status == 'pass' || item?.schedule_reports?.status == 'failed') && !item?.schedule_reports?.checklist_ticket_id && (status != "completed" && status != "failed") &&
                                                                                    <img
                                                                                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                                                        src="/images/undo.svg"
                                                                                        onClick={() => { RevertStatus(item) }}
                                                                                    />
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        {/* Expanded location sub-items */}
                                                                        {isExpanded && filteredItems.length > 0 && (
                                                                            <div style={{
                                                                                marginLeft: 22,
                                                                                borderLeft: '2px solid #f0f0f0',
                                                                                paddingLeft: 12,
                                                                                paddingBottom: 6,
                                                                                marginBottom: 4
                                                                            }}>
                                                                                {filteredItems.map((fi, fiIdx) => (
                                                                                    <div key={fi.id || fiIdx} style={{
                                                                                        display: 'flex', alignItems: 'center', gap: 8,
                                                                                        padding: '4px 0', position: 'relative'
                                                                                    }}>
                                                                                        <div style={{
                                                                                            position: 'absolute', left: -12, top: '50%',
                                                                                            width: 8, height: 0, borderTop: '2px solid #f0f0f0'
                                                                                        }} />
                                                                                        <img src='/images/location-blue.svg' style={{ width: 18, height: 18 }} />
                                                                                        <span style={{ fontSize: 12, color: '#666' }}>
                                                                                            {fi?.item_description || 'no name'}
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>

                                                </div>
                                            );
                                        })}
                                    </div>

                                    <Grid container gap={2} className='justify-content-end'>

                                        {/* Create Generalize Ticket Button */}
                                        {(!generalizedTicket || generalizedTicket == null) ?
                                            <Grid item xs={6} md={'auto'} className='btn-check-2'>
                                                <ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
                                                    disabled={status == "completed" || status == "failed"}
                                                    onClick={() => {
                                                        setAddModal(true)
                                                        setDisableItem(true)
                                                        setItemName('')
                                                        setLocName('')
                                                    }}>
                                                    Create Generalize Ticket
                                                </ButtonTheme>
                                            </Grid>
                                            :
                                            <>
                                                <Grid item xs={6} md={'auto'}
                                                    onClick={() => { setGeneralModal(true) }}>
                                                    <ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'>
                                                        View Ticket
                                                    </ButtonTheme>
                                                </Grid>

                                                <Grid item xs={6} md={'auto'}>
                                                    <ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
                                                        disabled={status == "completed" || status == "failed"}
                                                        onClick={() => {
                                                            setDeleteId(generalizedTicket?.id)
                                                            setDeleteModal(true)
                                                        }}>
                                                        Delete Ticket
                                                    </ButtonTheme>
                                                </Grid>
                                            </>
                                        }

                                        {/* Submit Button */}
                                        <Grid item xs={6} md={'auto'}>
                                            <ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
                                                disabled={!checklistItems || !checklistItems.length > 0 || checklistItems.find((a) => a.schedule_reports == null) || status == "completed" || status == "failed"}
                                                onClick={() => Submit()}>
                                                Submit
                                            </ButtonTheme>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Paper >

                    {addModal &&
                        <CreateTicket addModal={addModal} setAddModal={setAddModal} scheduleReportId={scheduleReportId}
                            disableItem={disableItem} checklistItemId={checklistItemId} getChecklistItems={getChecklistItems}
                            itemName={itemName} locName={locName} ticketAssigned={ticketAssigned} isStationChecklist={true}
                        />
                    }
                </>)}

            {/* View Ticket Pop-Up View */}
            <div className='font-fam'>
                <Modal className='checklist-modal' show={showModal} size="md" onHide={() => {
                    setShowModal(false)
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Ticket</Modal.Title>
                    </Modal.Header>
                    <div className='ticket-item-heading'>{ticketDetail?.title}</div>
                    <Modal.Body >
                        <Grid item xs={12} sm={6} md={6}>
                            <div className='font-fam model-bg'>

                                <div >
                                    <div className='ticket-margin row'>
                                        <div className='ticket-item'>{ticketDetail?.checklist_item?.location?.type == "location_item" ? "Location & Item :" : ticketDetail?.checklist_item?.location?.type == "location" ? "Location :" : "Item :"} {ticketDetail?.checklist_item?.location?.location_description || ticketDetail?.checklist_item?.item_location?.item?.item_description} </div>
                                        <div className='ticket-todo'>{ticketDetail?.tickteting_status?.status &&
                                            ticketDetail.tickteting_status.status.charAt(0).toUpperCase() +
                                            ticketDetail.tickteting_status.status.slice(1)}</div>
                                    </div>

                                    <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{ticketDetail?.employee_first_name ? ticketDetail?.employee_first_name + ' ' + ticketDetail?.employee_last_name : 'Unassigned'}</span> </div>
                                    </div>
                                    {/* 
                                    <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{ticketDetail?.notify_employee_first_name + ' ' + ticketDetail?.notify_employee_last_name || 'Unassigned'}</span> </div>
                                    </div> */}

                                    <div className="col-md-7 mt-1">
                                        <Typography variant="h6">
                                            Description
                                        </Typography>
                                    </div>

                                    <div className='row'>
                                        <div className='col' style={{ color: '#555555' }}>{ticketDetail?.description}</div>
                                    </div>

                                    <div className='row mt-2'>
                                        <div className='col'>
                                            <Typography variant="h6">
                                                Image
                                            </Typography>
                                            {ticketDetail?.image || ticketDetail?.secondary_image ? (
                                                <>
                                                    {ticketDetail?.image != null &&
                                                        <img src={ticketDetail?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                    {ticketDetail?.secondary_image != null &&
                                                        <img src={ticketDetail?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                </>
                                            ) :
                                                <p>No Image Uploaded</p>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Modal.Body>
                </Modal>
            </div >

            {/* View Ticket Generalized Pop-Up View */}
            < div className='font-fam' >
                <Modal className='checklist-modal' show={generalModal} size="md" onHide={() => {
                    setGeneralModal(false)
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Generalized Ticket</Modal.Title>
                    </Modal.Header>
                    <div className='ticket-item-heading'>{generalizedTicket?.title}</div>
                    <Modal.Body >
                        <Grid item xs={12} sm={6} md={6}>
                            <div className='font-fam model-bg'>

                                <div >
                                    <div className='ticket-margin row'>
                                        <div className='ticket-item'>Generalized Ticket </div>
                                        <div className='ticket-todo'>{generalizedTicket?.tickteting_status?.status &&
                                            generalizedTicket.tickteting_status.status.charAt(0).toUpperCase() +
                                            generalizedTicket.tickteting_status.status.slice(1)}</div>
                                    </div>

                                    <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{generalizedTicket?.employee_first_name ? generalizedTicket?.employee_first_name + ' ' + generalizedTicket?.employee_last_name : "Unassigned"}</span> </div>
                                    </div>

                                    {/* <div className='ticket-margin row'>
                                        <div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{generalizedTicket?.notify_employee_first_name + ' ' + generalizedTicket?.notify_employee_last_name}</span> </div>
                                    </div> */}

                                    <div className="col-md-7 mt-1">
                                        <Typography variant="h6">
                                            Description
                                        </Typography>
                                    </div>

                                    <div className='row'>
                                        <div className='col' style={{ color: '#555555' }}>{generalizedTicket?.description}</div>
                                    </div>

                                    <div className='row mt-2'>
                                        <div className='col'>
                                            <Typography variant="h6">
                                                Image
                                            </Typography>
                                            {generalizedTicket?.image || generalizedTicket?.secondary_image ? (
                                                <>
                                                    {generalizedTicket?.image != null &&
                                                        <img src={generalizedTicket?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                    {generalizedTicket?.secondary_image != null &&
                                                        <img src={generalizedTicket?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
                                                    }
                                                </>
                                            ) :
                                                <p>No Image Uploaded</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Grid>
                    </Modal.Body>
                </Modal>
            </div >

            {/* Delete Ticket Pop-Up View */}
            < div className='font-fam' >
                <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                    <Modal.Header closeButton>

                        <Modal.Title>Delete Checklist Item</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div style={{ color: '#555555' }}>
                            Are you sure you want to delete this ticket?
                        </div>
                        <Row>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                    setDeleteModal(false)
                                }}>
                                    Cancel
                                </ButtonTheme>
                            </Col>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={deleteItem}>
                                    Delete
                                </ButtonTheme>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </div >
        </>
    )
}
export default MyStationChecklistItems;